// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk",
  "zh-hans"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_c96eef91",
      load: () => import("#nuxt-i18n/c96eef91" /* webpackChunkName: "locale_en_46json_c96eef91" */),
      cache: true
    },
    {
      key: "locale_en_46json_4afd3375",
      load: () => import("#nuxt-i18n/4afd3375" /* webpackChunkName: "locale_en_46json_4afd3375" */),
      cache: true
    },
    {
      key: "locale_en_46json_edf2d4b6",
      load: () => import("#nuxt-i18n/edf2d4b6" /* webpackChunkName: "locale_en_46json_edf2d4b6" */),
      cache: true
    },
    {
      key: "locale_en_46json_40d549ca",
      load: () => import("#nuxt-i18n/40d549ca" /* webpackChunkName: "locale_en_46json_40d549ca" */),
      cache: true
    },
    {
      key: "locale_en_46json_b75ef6d4",
      load: () => import("#nuxt-i18n/b75ef6d4" /* webpackChunkName: "locale_en_46json_b75ef6d4" */),
      cache: true
    },
    {
      key: "locale_en_46json_8c96d751",
      load: () => import("#nuxt-i18n/8c96d751" /* webpackChunkName: "locale_en_46json_8c96d751" */),
      cache: true
    },
    {
      key: "locale_en_46json_ef13cb2c",
      load: () => import("#nuxt-i18n/ef13cb2c" /* webpackChunkName: "locale_en_46json_ef13cb2c" */),
      cache: true
    },
    {
      key: "locale_en_46json_212de4a7",
      load: () => import("#nuxt-i18n/212de4a7" /* webpackChunkName: "locale_en_46json_212de4a7" */),
      cache: true
    },
    {
      key: "locale_en_46json_b967fa95",
      load: () => import("#nuxt-i18n/b967fa95" /* webpackChunkName: "locale_en_46json_b967fa95" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_d1c42ac6",
      load: () => import("#nuxt-i18n/d1c42ac6" /* webpackChunkName: "locale_fr_46json_d1c42ac6" */),
      cache: true
    },
    {
      key: "locale_fr_46json_432fab27",
      load: () => import("#nuxt-i18n/432fab27" /* webpackChunkName: "locale_fr_46json_432fab27" */),
      cache: true
    },
    {
      key: "locale_fr_46json_70502785",
      load: () => import("#nuxt-i18n/70502785" /* webpackChunkName: "locale_fr_46json_70502785" */),
      cache: true
    },
    {
      key: "locale_fr_46json_7f3d4e79",
      load: () => import("#nuxt-i18n/7f3d4e79" /* webpackChunkName: "locale_fr_46json_7f3d4e79" */),
      cache: true
    },
    {
      key: "locale_fr_46json_a2dfa7be",
      load: () => import("#nuxt-i18n/a2dfa7be" /* webpackChunkName: "locale_fr_46json_a2dfa7be" */),
      cache: true
    },
    {
      key: "locale_fr_46json_07dda248",
      load: () => import("#nuxt-i18n/07dda248" /* webpackChunkName: "locale_fr_46json_07dda248" */),
      cache: true
    },
    {
      key: "locale_fr_46json_cc1b2ea8",
      load: () => import("#nuxt-i18n/cc1b2ea8" /* webpackChunkName: "locale_fr_46json_cc1b2ea8" */),
      cache: true
    },
    {
      key: "locale_fr_46json_cd954314",
      load: () => import("#nuxt-i18n/cd954314" /* webpackChunkName: "locale_fr_46json_cd954314" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6d31e2f4",
      load: () => import("#nuxt-i18n/6d31e2f4" /* webpackChunkName: "locale_fr_46json_6d31e2f4" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_6e74c07a",
      load: () => import("#nuxt-i18n/6e74c07a" /* webpackChunkName: "locale_nl_46json_6e74c07a" */),
      cache: true
    },
    {
      key: "locale_nl_46json_94f7b7ed",
      load: () => import("#nuxt-i18n/94f7b7ed" /* webpackChunkName: "locale_nl_46json_94f7b7ed" */),
      cache: true
    },
    {
      key: "locale_nl_46json_a9c35ded",
      load: () => import("#nuxt-i18n/a9c35ded" /* webpackChunkName: "locale_nl_46json_a9c35ded" */),
      cache: true
    },
    {
      key: "locale_nl_46json_55730b2c",
      load: () => import("#nuxt-i18n/55730b2c" /* webpackChunkName: "locale_nl_46json_55730b2c" */),
      cache: true
    },
    {
      key: "locale_nl_46json_5dc33857",
      load: () => import("#nuxt-i18n/5dc33857" /* webpackChunkName: "locale_nl_46json_5dc33857" */),
      cache: true
    },
    {
      key: "locale_nl_46json_255337ce",
      load: () => import("#nuxt-i18n/255337ce" /* webpackChunkName: "locale_nl_46json_255337ce" */),
      cache: true
    },
    {
      key: "locale_nl_46json_4d163b80",
      load: () => import("#nuxt-i18n/4d163b80" /* webpackChunkName: "locale_nl_46json_4d163b80" */),
      cache: true
    },
    {
      key: "locale_nl_46json_51c94ed7",
      load: () => import("#nuxt-i18n/51c94ed7" /* webpackChunkName: "locale_nl_46json_51c94ed7" */),
      cache: true
    },
    {
      key: "locale_nl_46json_9adcb9a9",
      load: () => import("#nuxt-i18n/9adcb9a9" /* webpackChunkName: "locale_nl_46json_9adcb9a9" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_d968ec34",
      load: () => import("#nuxt-i18n/d968ec34" /* webpackChunkName: "locale_de_46json_d968ec34" */),
      cache: true
    },
    {
      key: "locale_de_46json_4859a136",
      load: () => import("#nuxt-i18n/4859a136" /* webpackChunkName: "locale_de_46json_4859a136" */),
      cache: true
    },
    {
      key: "locale_de_46json_48de4654",
      load: () => import("#nuxt-i18n/48de4654" /* webpackChunkName: "locale_de_46json_48de4654" */),
      cache: true
    },
    {
      key: "locale_de_46json_63124934",
      load: () => import("#nuxt-i18n/63124934" /* webpackChunkName: "locale_de_46json_63124934" */),
      cache: true
    },
    {
      key: "locale_de_46json_e3f33d47",
      load: () => import("#nuxt-i18n/e3f33d47" /* webpackChunkName: "locale_de_46json_e3f33d47" */),
      cache: true
    },
    {
      key: "locale_de_46json_58a6e21b",
      load: () => import("#nuxt-i18n/58a6e21b" /* webpackChunkName: "locale_de_46json_58a6e21b" */),
      cache: true
    },
    {
      key: "locale_de_46json_495214eb",
      load: () => import("#nuxt-i18n/495214eb" /* webpackChunkName: "locale_de_46json_495214eb" */),
      cache: true
    },
    {
      key: "locale_de_46json_de8fa242",
      load: () => import("#nuxt-i18n/de8fa242" /* webpackChunkName: "locale_de_46json_de8fa242" */),
      cache: true
    },
    {
      key: "locale_de_46json_1aa72e65",
      load: () => import("#nuxt-i18n/1aa72e65" /* webpackChunkName: "locale_de_46json_1aa72e65" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_4754da95",
      load: () => import("#nuxt-i18n/4754da95" /* webpackChunkName: "locale_es_46json_4754da95" */),
      cache: true
    },
    {
      key: "locale_es_46json_92b11728",
      load: () => import("#nuxt-i18n/92b11728" /* webpackChunkName: "locale_es_46json_92b11728" */),
      cache: true
    },
    {
      key: "locale_es_46json_ecb926f8",
      load: () => import("#nuxt-i18n/ecb926f8" /* webpackChunkName: "locale_es_46json_ecb926f8" */),
      cache: true
    },
    {
      key: "locale_es_46json_dc6f0006",
      load: () => import("#nuxt-i18n/dc6f0006" /* webpackChunkName: "locale_es_46json_dc6f0006" */),
      cache: true
    },
    {
      key: "locale_es_46json_e6218e0f",
      load: () => import("#nuxt-i18n/e6218e0f" /* webpackChunkName: "locale_es_46json_e6218e0f" */),
      cache: true
    },
    {
      key: "locale_es_46json_9ead1a10",
      load: () => import("#nuxt-i18n/9ead1a10" /* webpackChunkName: "locale_es_46json_9ead1a10" */),
      cache: true
    },
    {
      key: "locale_es_46json_06432ffc",
      load: () => import("#nuxt-i18n/06432ffc" /* webpackChunkName: "locale_es_46json_06432ffc" */),
      cache: true
    },
    {
      key: "locale_es_46json_36797fc6",
      load: () => import("#nuxt-i18n/36797fc6" /* webpackChunkName: "locale_es_46json_36797fc6" */),
      cache: true
    },
    {
      key: "locale_es_46json_fd2d7187",
      load: () => import("#nuxt-i18n/fd2d7187" /* webpackChunkName: "locale_es_46json_fd2d7187" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_bc108895",
      load: () => import("#nuxt-i18n/bc108895" /* webpackChunkName: "locale_it_46json_bc108895" */),
      cache: true
    },
    {
      key: "locale_it_46json_40a13320",
      load: () => import("#nuxt-i18n/40a13320" /* webpackChunkName: "locale_it_46json_40a13320" */),
      cache: true
    },
    {
      key: "locale_it_46json_1473bf56",
      load: () => import("#nuxt-i18n/1473bf56" /* webpackChunkName: "locale_it_46json_1473bf56" */),
      cache: true
    },
    {
      key: "locale_it_46json_e4307a57",
      load: () => import("#nuxt-i18n/e4307a57" /* webpackChunkName: "locale_it_46json_e4307a57" */),
      cache: true
    },
    {
      key: "locale_it_46json_a38cceca",
      load: () => import("#nuxt-i18n/a38cceca" /* webpackChunkName: "locale_it_46json_a38cceca" */),
      cache: true
    },
    {
      key: "locale_it_46json_1e9834ff",
      load: () => import("#nuxt-i18n/1e9834ff" /* webpackChunkName: "locale_it_46json_1e9834ff" */),
      cache: true
    },
    {
      key: "locale_it_46json_bb6574c2",
      load: () => import("#nuxt-i18n/bb6574c2" /* webpackChunkName: "locale_it_46json_bb6574c2" */),
      cache: true
    },
    {
      key: "locale_it_46json_2cd0ae16",
      load: () => import("#nuxt-i18n/2cd0ae16" /* webpackChunkName: "locale_it_46json_2cd0ae16" */),
      cache: true
    },
    {
      key: "locale_it_46json_1c35d0dc",
      load: () => import("#nuxt-i18n/1c35d0dc" /* webpackChunkName: "locale_it_46json_1c35d0dc" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_beb60cdf",
      load: () => import("#nuxt-i18n/beb60cdf" /* webpackChunkName: "locale_pl_46json_beb60cdf" */),
      cache: true
    },
    {
      key: "locale_pl_46json_43586670",
      load: () => import("#nuxt-i18n/43586670" /* webpackChunkName: "locale_pl_46json_43586670" */),
      cache: true
    },
    {
      key: "locale_pl_46json_42b81165",
      load: () => import("#nuxt-i18n/42b81165" /* webpackChunkName: "locale_pl_46json_42b81165" */),
      cache: true
    },
    {
      key: "locale_pl_46json_be223fed",
      load: () => import("#nuxt-i18n/be223fed" /* webpackChunkName: "locale_pl_46json_be223fed" */),
      cache: true
    },
    {
      key: "locale_pl_46json_d286c9e4",
      load: () => import("#nuxt-i18n/d286c9e4" /* webpackChunkName: "locale_pl_46json_d286c9e4" */),
      cache: true
    },
    {
      key: "locale_pl_46json_fd449186",
      load: () => import("#nuxt-i18n/fd449186" /* webpackChunkName: "locale_pl_46json_fd449186" */),
      cache: true
    },
    {
      key: "locale_pl_46json_0b337442",
      load: () => import("#nuxt-i18n/0b337442" /* webpackChunkName: "locale_pl_46json_0b337442" */),
      cache: true
    },
    {
      key: "locale_pl_46json_f9dd6b03",
      load: () => import("#nuxt-i18n/f9dd6b03" /* webpackChunkName: "locale_pl_46json_f9dd6b03" */),
      cache: true
    },
    {
      key: "locale_pl_46json_7906c2fa",
      load: () => import("#nuxt-i18n/7906c2fa" /* webpackChunkName: "locale_pl_46json_7906c2fa" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_64881c89",
      load: () => import("#nuxt-i18n/64881c89" /* webpackChunkName: "locale_ko_46json_64881c89" */),
      cache: true
    },
    {
      key: "locale_ko_46json_2489e849",
      load: () => import("#nuxt-i18n/2489e849" /* webpackChunkName: "locale_ko_46json_2489e849" */),
      cache: true
    },
    {
      key: "locale_ko_46json_231e15ab",
      load: () => import("#nuxt-i18n/231e15ab" /* webpackChunkName: "locale_ko_46json_231e15ab" */),
      cache: true
    },
    {
      key: "locale_ko_46json_d40398cd",
      load: () => import("#nuxt-i18n/d40398cd" /* webpackChunkName: "locale_ko_46json_d40398cd" */),
      cache: true
    },
    {
      key: "locale_ko_46json_3e25b09e",
      load: () => import("#nuxt-i18n/3e25b09e" /* webpackChunkName: "locale_ko_46json_3e25b09e" */),
      cache: true
    },
    {
      key: "locale_ko_46json_8e721cbd",
      load: () => import("#nuxt-i18n/8e721cbd" /* webpackChunkName: "locale_ko_46json_8e721cbd" */),
      cache: true
    },
    {
      key: "locale_ko_46json_74bdceab",
      load: () => import("#nuxt-i18n/74bdceab" /* webpackChunkName: "locale_ko_46json_74bdceab" */),
      cache: true
    },
    {
      key: "locale_ko_46json_c5b72f7b",
      load: () => import("#nuxt-i18n/c5b72f7b" /* webpackChunkName: "locale_ko_46json_c5b72f7b" */),
      cache: true
    },
    {
      key: "locale_ko_46json_892ff85c",
      load: () => import("#nuxt-i18n/892ff85c" /* webpackChunkName: "locale_ko_46json_892ff85c" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_d38492e6",
      load: () => import("#nuxt-i18n/d38492e6" /* webpackChunkName: "locale_uk_46json_d38492e6" */),
      cache: true
    },
    {
      key: "locale_uk_46json_df417093",
      load: () => import("#nuxt-i18n/df417093" /* webpackChunkName: "locale_uk_46json_df417093" */),
      cache: true
    },
    {
      key: "locale_uk_46json_85d01fa6",
      load: () => import("#nuxt-i18n/85d01fa6" /* webpackChunkName: "locale_uk_46json_85d01fa6" */),
      cache: true
    },
    {
      key: "locale_uk_46json_10370f0a",
      load: () => import("#nuxt-i18n/10370f0a" /* webpackChunkName: "locale_uk_46json_10370f0a" */),
      cache: true
    },
    {
      key: "locale_uk_46json_87872b8b",
      load: () => import("#nuxt-i18n/87872b8b" /* webpackChunkName: "locale_uk_46json_87872b8b" */),
      cache: true
    },
    {
      key: "locale_uk_46json_a6949641",
      load: () => import("#nuxt-i18n/a6949641" /* webpackChunkName: "locale_uk_46json_a6949641" */),
      cache: true
    },
    {
      key: "locale_uk_46json_bdecec4e",
      load: () => import("#nuxt-i18n/bdecec4e" /* webpackChunkName: "locale_uk_46json_bdecec4e" */),
      cache: true
    },
    {
      key: "locale_uk_46json_ff700225",
      load: () => import("#nuxt-i18n/ff700225" /* webpackChunkName: "locale_uk_46json_ff700225" */),
      cache: true
    },
    {
      key: "locale_uk_46json_6b59aca6",
      load: () => import("#nuxt-i18n/6b59aca6" /* webpackChunkName: "locale_uk_46json_6b59aca6" */),
      cache: true
    }
  ],
  "zh-hans": [
    {
      key: "locale_zh_Hans_46json_fb2be849",
      load: () => import("#nuxt-i18n/fb2be849" /* webpackChunkName: "locale_zh_Hans_46json_fb2be849" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_d98b8197",
      load: () => import("#nuxt-i18n/d98b8197" /* webpackChunkName: "locale_zh_Hans_46json_d98b8197" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_a2d29646",
      load: () => import("#nuxt-i18n/a2d29646" /* webpackChunkName: "locale_zh_Hans_46json_a2d29646" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_3ccaa2a8",
      load: () => import("#nuxt-i18n/3ccaa2a8" /* webpackChunkName: "locale_zh_Hans_46json_3ccaa2a8" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_fc085b8e",
      load: () => import("#nuxt-i18n/fc085b8e" /* webpackChunkName: "locale_zh_Hans_46json_fc085b8e" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_8b490bf5",
      load: () => import("#nuxt-i18n/8b490bf5" /* webpackChunkName: "locale_zh_Hans_46json_8b490bf5" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_950f5e80",
      load: () => import("#nuxt-i18n/950f5e80" /* webpackChunkName: "locale_zh_Hans_46json_950f5e80" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_c879158e",
      load: () => import("#nuxt-i18n/c879158e" /* webpackChunkName: "locale_zh_Hans_46json_c879158e" */),
      cache: true
    },
    {
      key: "locale_zh_Hans_46json_f8118507",
      load: () => import("#nuxt-i18n/f8118507" /* webpackChunkName: "locale_zh_Hans_46json_f8118507" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  },
  {
    code: "zh-hans",
    language: "zh-Hans",
    name: "简体中文"
  }
]

